import React from 'react'
import { useState, useEffect } from 'react';
import Header from '../components/Header';
import CategoryTabs from '../components/CategoryTabs';
import MenuItems from '../components/MenuItems';
import SlideShow from '../components/SlideShow';
export default function Home() {
    const [menuData, setMenuData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [language, setLanguage] = useState('en'); // Default language
    const [slider , setSlider] = useState([]);

    useEffect(() => {
        
      // Fetch menu data from API
      const fetchMenuData = async () => {
        try {
          // Replace with your actual API endpoint
          const response = await fetch('https://api.floranya.co/menu');
          if (!response.ok) {
            throw new Error('Failed to fetch menu data');
          }
          const data = await response.json();
          setMenuData(data);
          // Set the first category as selected by default
          if (data.length > 0) {
            setSelectedCategory(data[0].id);
          }
          setLoading(false);
        } catch (err) {
          setError(err.message);
          setLoading(false);
        }
      };
  
      fetchMenuData();
    }, []);
    console.log(slider)
    const handleCategoryChange = (categoryId) => {
      setSelectedCategory(categoryId);
    };
  
    const handleLanguageChange = (newLanguage) => {
      setLanguage(newLanguage);
    };

  
    if (loading) return <div className="loading">Loading menu data...</div>;
    if (error) return <div className="error">Error: {error}</div>;
  
    return (
      <div className="app">
        <Header language={language} onLanguageChange={handleLanguageChange} />
        <div className="hero-section">
         <SlideShow/>
        </div>
        <CategoryTabs 
          categories={menuData} 
          selectedCategory={selectedCategory}
          onCategoryChange={handleCategoryChange}
          language={language}
        />
        <MenuItems 
          categories={menuData}
          selectedCategory={selectedCategory}
          language={language}
        />
      </div>
    );
  
}
